export const fileName = (fullName: string): string => {
  const lastDotIndex = fullName?.lastIndexOf('.');
  if (lastDotIndex === -1) return fullName;
  return fullName?.slice(0, lastDotIndex);
};

export const fileExtension = (fileName: string): string => {
  const lastDotIndex = fileName.lastIndexOf('.');
  if (lastDotIndex === -1) return '';
  return fileName.slice(lastDotIndex + 1).toLowerCase();
};

export const colorToRgb = (hex: string) => {
  if (hex === 'transparent') {
    return {
      r: 0,
      g: 0,
      b: 0,
      a: 0,
    };
  }

  if (hex.includes('rgb')) {
    return parseRGB(hex);
  }

  hex = hex.replace(/^#/, '');

  if (hex.length === 3) {
    hex = hex
      .split('')
      .map((char) => char + char)
      .join('');
  }

  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);

  return {
    r: r,
    g: g,
    b: b,
    a: 1,
  };
};

export const RGBAToSring = (color: {
  r: number;
  g: number;
  b: number;
  a: number;
}) => {
  return `rgba(${color?.r!},${color?.g!},${color?.b!},${color?.a!})`;
};

export const RGBToSring = (color: { r: number; g: number; b: number }) => {
  return `rgb(${color.r},${color.g},${color.b})`;
};

export const stringToRGBA = (color: string) => {
  const rgbaRegex = /rgba?\((\d+),\s*(\d+),\s*(\d+),\s*([\d.]+)\)/;
  const match = color.match(rgbaRegex);

  if (match) {
    return {
      r: parseInt(match[1], 10),
      g: parseInt(match[2], 10),
      b: parseInt(match[3], 10),
      a: parseFloat(match[4]),
    };
  } else {
    return colorToRgb(color);
  }
};

const parseRGB = (rgbString: string) => {
  const match = rgbString.match(/rgb\((\d+),\s*(\d+),\s*(\d+)\)/);
  if (!match) {
    throw new Error('Geçerli bir RGB formatı değil');
  }

  return {
    r: parseInt(match[1], 10),
    g: parseInt(match[2], 10),
    b: parseInt(match[3], 10),
    a: 1,
  };
};

export const formatFileSize = (size: number): string => {
  if (size < 1024) return `${size} B`;
  else if (size < 1024 * 1024) return `${(size / 1024).toFixed(2)} KB`;
  else if (size < 1024 * 1024 * 1024)
    return `${(size / (1024 * 1024)).toFixed(2)} MB`;
  else return `${(size / (1024 * 1024 * 1024)).toFixed(2)} GB`;
};

export const reverseToolKey = (input: string): string => {
  const parts = input.split('-to-');
  if (parts.length !== 2) {
    throw new Error("Invalid input format. Expected format: 'x-to-y'");
  }
  return `${parts[1]}-to-${parts[0]}`;
};

export const generateFileName = (): string => {
  return Math.floor(1000000000 + Math.random() * 9000000000).toString();
};

export const formatAnalyticsSource = (source?: string): string => {
  if (!source) return 'unknown';

  let normalized = source.toLowerCase().trim();
  normalized = normalized.split('?')[0];
  if (normalized.includes('/')) {
    const parts = normalized.split('/').filter(Boolean);
    normalized = parts[parts.length - 1] || normalized;
  }

  if (normalized.endsWith('-converter') && normalized !== 'pdf-converter') {
    normalized = normalized.slice(0, -'-converter'.length);
  }

  const TOOL_SOURCE_MAP: Record<string, string> = {
    sign: 'esign-pdf',
    'sign-pdf': 'esign-pdf',
    'pdf-to-jpg': 'pdf-to-image',
    'pdf-to-jpeg': 'pdf-to-image',
    'jpg-to-pdf': 'image-to-pdf',
    'jpeg-to-pdf': 'image-to-pdf',
    'pdf-to-ppt': 'pdf-to-powerpoint',
    'ppt-to-pdf': 'powerpoint-to-pdf',
    'convert-pdf': 'pdf-converter',
    compress: 'compress-pdf',
    'annotate-pdf': 'pdf-annotator',
    'pdf-editor': 'edit-pdf',
  };
  normalized = TOOL_SOURCE_MAP[normalized] ?? normalized;

  return normalized.replace(/[-\s]/g, '_');
};
